import Vue from "vue";
import base from "./baseBeholder";

export default Object.assign(
    {
        apiUrl: "",

        async getMonitorStatistics({ min: startDate, max: endDate, networks }) {
            const url = this.url('/monitor/statistics');
            return Vue.http.get(url, {
                params: {
                    startDate,
                    endDate,
                    networks
                }
            });
        },
        async getControllerNetworks(controllerId) {
            return Vue.http.get(this.url(`/access-point/${controllerId}/networks`));
        },

        async getMonitorNetworks() {
            return Vue.http.get(this.url('/monitor/networks'));
        }
    },
    base
);
